import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=e53f840a&scoped=true&"
import script from "./PaymentMethod.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethod.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethod.vue?vue&type=style&index=0&id=e53f840a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53f840a",
  null
  
)

export default component.exports